import { Reveal } from "@/components/Reveal";
import { Chapter } from "@/components/Chapter";
import { DOCTORS } from "@/data/site";

const TESTIMONIALS = [
  {
    quote:
      "Professionalità eccellente, come eccellente l'accoglienza, la disponibilità e la comprensione delle problematiche connesse alle richieste delle prestazioni.",
    author: "Marco G.",
  },
  {
    quote: "Professionista serio e molto competente in materia. Consiglio.",
    author: "Germana D.R.",
  },
  {
    quote: "Professionista molto competente, empatico, con doti di grande umanità.",
    author: "Vincia T.",
  },
];

export const About = () => (
  <section id="chi-siamo" data-testid="section-chi-siamo" className="bg-paper py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter
          number="03"
          kicker="Chi Siamo"
          title="Chi sono i medici competenti di BPMedLav?"
        />
      </Reveal>

      <div className="grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <blockquote className="font-display italic text-2xl md:text-3xl leading-snug text-ink border-l-4 border-clinic pl-6">
            "Fornire piena collaborazione ai datori di lavoro per il rispetto delle norme e, al
            tempo stesso, prestare la massima attenzione ai bisogni di salute e sicurezza dei
            lavoratori."
          </blockquote>
        </Reveal>
        <div className="lg:col-span-7 grid gap-px bg-ink/10 border border-ink/10 sm:grid-cols-2">
          {DOCTORS.map((d, i) => (
            <Reveal key={d.id} delay={i * 0.1} className="bg-paper">
              <article className="h-full p-8 md:p-10" data-testid={`doctor-card-${d.id}`}>
                <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-clinic-tint font-display text-2xl text-clinic">
                  {d.name.split(" ").slice(-1)[0][0]}
                </div>
                <h3 className="font-display text-2xl text-ink mb-2">{d.name}</h3>
                <p className="text-sm leading-relaxed text-ink/70 mb-4">{d.jobTitle}</p>
                <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-ink/50">
                  {d.order}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-20">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-clinic mb-8">
            Testimonianze — Recensioni reali dal profilo Google
          </p>
        </Reveal>
        <div className="grid gap-px bg-ink/10 border border-ink/10 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.author} delay={i * 0.08} className="bg-paper">
              <figure className="h-full p-8" data-testid={`testimonial-${i}`}>
                <blockquote className="font-display italic text-lg leading-relaxed text-ink/85 mb-6">
                  "{t.quote}"
                </blockquote>
                <figcaption className="font-mono text-[10px] tracking-[0.2em] uppercase text-ink/50">
                  {t.author}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
